import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { I18nProvider } from './i18n';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MonthView from './pages/MonthView';
import TimeEntriesView from './pages/TimeEntriesView';
import YearView from './pages/YearView';
import AllTimeView from './pages/AllTimeView';
import RequestsView from './pages/RequestsView';
import AbsenceView from './pages/AbsenceView';
import CalendarView from './pages/CalendarView';
import AdminOverview from './pages/admin/AdminOverview';
import AdminUsers from './pages/admin/AdminUsers';
import AdminUserDetail from './pages/admin/AdminUserDetail';
import AdminRoles from './pages/admin/AdminRoles';
import AdminSchedules from './pages/admin/AdminSchedules';
import AdminTeam from './pages/admin/AdminTeam';
import AdminTeams from './pages/admin/AdminTeams';
import AdminCompany from './pages/admin/AdminCompany';

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <div className="container-fluid py-4">{children}</div>
    </>
  );
}

export default function App() {
  return (
    <I18nProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
          } />
          <Route path="/times" element={
            <ProtectedRoute><Layout><TimeEntriesView /></Layout></ProtectedRoute>
          } />
          <Route path="/month" element={
            <ProtectedRoute><Layout><MonthView /></Layout></ProtectedRoute>
          } />
          <Route path="/year" element={
            <ProtectedRoute><Layout><YearView /></Layout></ProtectedRoute>
          } />
          <Route path="/alltime" element={
            <ProtectedRoute><Layout><AllTimeView /></Layout></ProtectedRoute>
          } />
          <Route path="/requests" element={
            <ProtectedRoute><Layout><RequestsView /></Layout></ProtectedRoute>
          } />
          <Route path="/vacation" element={<Navigate to="/requests" replace />} />
          <Route path="/absences" element={
            <ProtectedRoute><Layout><AbsenceView /></Layout></ProtectedRoute>
          } />
          <Route path="/calendar" element={
            <ProtectedRoute><Layout><CalendarView /></Layout></ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute anyOf={['manage_users', 'manage_subordinates', 'admin', 'manage_schedules', 'view_team_time']}><Layout><AdminOverview /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute anyOf={['manage_users', 'manage_subordinates']}><Layout><AdminUsers /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/users/:id" element={
            <ProtectedRoute anyOf={['manage_users', 'manage_subordinates']}><Layout><AdminUserDetail /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/roles" element={
            <ProtectedRoute permission="admin"><Layout><AdminRoles /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/schedules" element={
            <ProtectedRoute permission="manage_schedules"><Layout><AdminSchedules /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/team" element={
            <ProtectedRoute permission="view_team_time"><Layout><AdminTeam /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/teams" element={
            <ProtectedRoute anyOf={['manage_users', 'manage_subordinates']}><Layout><AdminTeams /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/company" element={
            <ProtectedRoute permission="admin"><Layout><AdminCompany /></Layout></ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </I18nProvider>
  );
}
